




























































import { Vue, Component } from 'vue-property-decorator'
import { AvailableResult, Credentials, NativeBiometric } from 'capacitor-native-biometric'
import { emailRules, passwordRules } from '@/util/inputValidation'
import Arrows from '@/components/Arrows.vue'
import { signIn } from '@/services/auth'
import { showToast } from '@/services/app'
import { Capacitor } from '@capacitor/core'

@Component({
  metaInfo: {
    title: 'Sign in',
  },
  components: {
    Arrows,
  },
})
export default class SignIn extends Vue {
  form = {
    email: '',
    password: '',
    useBiometrics: false,
    rememberMe: false,
  }
  showPassword = false
  isValid = false
  loading = false
  biometricsAvailable = false
  rules = {
    email: emailRules,
    password: passwordRules,
  }

  async mounted() {
    if (this.$route.params.email) {
      this.form.email = this.$route.params.email
    }
    if (await this.checkBiometricsAvailable())
      this.loadCredentialsFromBiometrics()
  }

  get usingSandbox() {
    return this.form.email.includes('+test')
  }

  async signIn(email?: string, password?: string, rememberMe?: boolean) {
    this.loading = true
    try {
      if (!email) email = this.form.email
      if (!password) password = this.form.password
      if (rememberMe === undefined) rememberMe = this.form.rememberMe

      const data = await signIn(this.$store, email, password, rememberMe)

      // TODO: Find better way to determine login success
      if (data?.response?.user) {
        const biometricsAvailable = await this.checkBiometricsAvailable()

        if (biometricsAvailable)
          this.saveCredentials(this.form.email, this.form.password)
      }
    } finally {
      this.loading = false
    }
  }

  async saveCredentials(email: string, password: string) {
    if (this.form.useBiometrics) {
      await NativeBiometric.setCredentials({
        username: email,
        password,
        server: 'worxstr.com',
      })
    }
  }

  async checkBiometricsAvailable() {
    if (!Capacitor.isNativePlatform()) return false
    const result: AvailableResult = await NativeBiometric.isAvailable()
    return this.biometricsAvailable = result.isAvailable
  }

  async loadCredentialsFromBiometrics() {

    const biometricsAvailable = await this.checkBiometricsAvailable()

    if (biometricsAvailable) {

      // Get user's credentials
      const credentials: Credentials = await NativeBiometric.getCredentials({
        server: 'worxstr.com',
      })

      try {
        // TODO: Only do this when the user has checked the "use biometrics" checkbox
        await NativeBiometric.verifyIdentity({
          reason: 'For easy sign in.',
          title: 'Log in with biometrics',
          subtitle: 'Your Worxstr credentials are saved securely on this device.',
        })
        
        // Authentication successful
        this.signIn(credentials.username, credentials.password, true)
      }
      catch (error) {
        showToast(this.$store, {
          text: "Couldn't sign in with biometrics."
        })
      }
    }
  }
}
